export enum CompanyProfileType {
	CLIENT = "client",
	SUPPLIER = "supplier",
	NONE = "NONE",
}
